<template>
  <custom-dialog title="请选择核销方式" :showClose="true" width="292px" v-if="visibleShow" :visible="visibleShow"
    @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
    <div slot="content">
      <div class="content_list">
        <div class="content_list_item" v-for="item in list" :key="item.id" @click="chooseType(item.id)">
          <img :src="item.icon" class="content_list_item_icon">
          <div>{{ item.name }}</div>
          <div v-if="item.id == 2 && usableList.length > 0" class="content_list_item_tips">有可用券</div>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import customDialog from '@/components/customDialog/CustomDialog'
import { imgArr } from '@/assets/images/img'
import { getCouponList } from '@/api/coupon'

export default {
  components: { customDialog },
  props: {
    visibleShow: {
      type: Boolean,
      default: false
    },
    dialogObj: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      list: [
        { icon: imgArr.couponScan, id: '1', name: '扫二维码核券' },
        { icon: imgArr.couponPhone, id: '2', name: '手机号码核券' },
      ],
      usableList:[],//可用券
    }
  },
  created() {
    console.log(this.dialogObj, 1111);
    this.getCouponList()
  },
  methods: {
    async getCouponList(){
      let { code, data } = await getCouponList({
        orderId: this.dialogObj.orderId,
        phone: this.dialogObj.memberPhone,
        couponIds: []
      })
      if(code === 200){
        this.usableList = data.usableList || []
      }
    },
    chooseType(id) {
      this.$emit('confirm', id)
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.content_list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.content_list_item {
  width: 220px;
  height: 54px;
  color: #000;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #D3D3D5;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

.content_list_item_icon {
  width: 14px;
  height: 14px;
  margin-right: 2px;
}

.content_list_item_tips {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 6px;
  font-weight: 400;
  font-size: 12px;
  color: #68481D;
  background: #FFE6AC;
  border-radius: 0px 4px 0px 4px;
}
</style>